import type { MouseEvent } from "react";
import { isPlainLeftClick } from "../../clicks";
import { Icon, type IconName } from "../../icons";

export interface SectionTab {
  id: string;
  label: string;
  href: string;
  icon?: IconName;
}

export interface SectionTabsProps {
  items: SectionTab[];
  active?: string;
  onNavigate?: (href: string) => void;
  ariaLabel: string;
}

/** Section navigation of a module: real links (one URL per section), underline indicator, scrolls horizontally on small screens. */
export function SectionTabs({ items, active, onNavigate, ariaLabel }: SectionTabsProps): React.JSX.Element {
  function onClick(e: MouseEvent<HTMLAnchorElement>, href: string): void {
    if (!onNavigate || !isPlainLeftClick(e)) return;
    e.preventDefault();
    onNavigate(href);
  }
  return (
    <nav className="nb-section-tabs" aria-label={ariaLabel}>
      <ul>
        {items.map((t) => (
          <li key={t.id}>
            <a href={t.href} aria-current={t.id === active ? "page" : undefined} onClick={(e) => onClick(e, t.href)}>
              {t.icon ? <Icon name={t.icon} /> : null}
              {t.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
